/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import { Link, styled } from "@mui/material";

export const StyledBreadCrumbContainer = styled("div")({
  height: "20px",
  width: "100%",
  backgroundColor: "#f5f5f8",
  padding: "10px 0px 10px 20px",
  borderColor: "#e0e0e0",
  borderWidth: "0px 0px 1px 0px",
  borderStyle: "solid",
});

export const StyledLink = styled(Link)(({ color }) => ({
  textDecoration: "none",
  color,
  fontSize: "13px",
  fontWeight: "400",
}));
